<template>
    <bar :options="option" class="echarts" ref="echartsize" :auto-resize="true" theme="walden"></bar>
</template>

<script>
import bar from "vue-echarts";
require('echarts');//引入所有表
import '@/assets/js/walden'
export default {
  name: 'DriverEchart',
    components: {
        bar
    },
  data () {
    return {
        option : {
            backgroundColor: '#FFFFFF',
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                padding : [40 , 0 , 0 , 0],
                data : [
                    {
                    name: '司机提成金额',
                    // 强制设置图形为圆。
                    icon: 'circle',
                }],
                // data: ['客户总数', '新增客户','跟进客户', '流失客户'],
            },
            grid : {
                left : '60px',
                top : '80px',
                right : '20px',
            },
            toolbox: {
                show: false,
                feature: {
                    magicType: {type: ['line', 'bar']},
                    saveAsImage: {}
                }
            },
            xAxis: {
                type: 'category',
                // boundaryGap: false,
                data: [],
                axisLabel: {    // 坐标轴标签
                    rotate: 30, // 旋转角度
                },
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}'
                },
            },
            series: [
                {
                    name: '司机提成金额',
                    type: 'bar',
                    barWidth: 24,
                    smooth : true,
                    data: [],
                    itemStyle: {
                        normal: {
                            barBorderRadius:[3, 3, 0, 0], // 设置柱状图圆角
                        }
                    }
                }
            ]
        },
    }
  },
    created(){
        // this.GetEchatStatic();
    },
    mounted(){
        let that = this;
        this.$nextTick(() => {
            this.$refs.echartsize.resize();
        })
    },
    methods: {
        GetDriverEchart(){
            let that = this;
            that.loading = true;
            that.$axios.get('/admin/index/getDriverStatic')
                .then(function (e) {
                    if(e.code == 0) {
                        let data = e.data;
                        that.option.xAxis.data = data.name;
                        that.option.series[0].data = data.static;
                    }else{
                        that.$Message.error({ background: true,duration:3, content:e.msg});
                    }
                })
                .catch(function (e) {
                    that.$Message.error({ background: true,duration:3, content:'请求发送失败'});
                });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>



// WEBPACK FOOTER //
// src/components/echart/DriverEchart.vue